const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Sign in",
    signUp: "Sign up",
    signInShort: "Sign in",
    signUpShort: "Sign up",
  },
  landing: {
    firstMessageBefore: "See ",
    firstMessageHighlight: "where your friends",
    firstMessageAfter: " went today.",
    secondMessageBefore: "Play with your friends in the ",
    secondMessageHighlight: "real world.",
  },
  search: {
    placeholder: "Find whatever you want...",
    ariaLabel: "Search",
  },
  feed: {
    untitled: "Untitled",
    channelFallback: "Channel",
    todayMomentsSubtitle: "Discover where your friends spend their best moments",
    todayMomentsLabel: "Your Moment",
    friendSpotsSection: "Your friends' spots",
    spotDistancePrefix: "At",
    loadMoreSpots: "See more",
    nearbyExploreTitle: "Explore near you",
    nearbyTreasureHuntsTitle: "IRL Quests",
    treasureHuntLabel: "IRL Quest",
    treasureHuntUnlockOnSite: "IRL quest to unlock on site",
    unlockOnSite: "Unlock on site",
    distanceAway: "{{distance}} away",
    mapFoundContent: "Content found",
    mapNoExploreFound: "No Explore found",
    openAction: "Open",
    startAction: "Start",
    trendingNow: "They are trending right now",
    categoriesTitle: "Categories",
  },
  video: {
    gameAvailable: "Game available on this video",
    clickToPlay: "Click to play",
    tapToPlay: "Tap to play",
    home: "Home",
    signInToLike: "Sign in to like",
    signInToComment: "Sign in to comment",
    exploreOnlyFromMap: "Explores can only be opened from the map or their dedicated section.",
    enableLocationForExplore: "Enable your location to view this Explore content.",
    noAnswer: "No answer",
    youtubeLikesUnavailable: "Likes unavailable on YouTube videos",
    addComment: "Add a comment...",
    commentsLockedAllAnswered:
      "Comments will unlock after you answer every game on this video at least once.",
    commentsLockedAllWon:
      "Comments will unlock after you win every game on this video at least once.",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Quick answer",
  },
  badges: {
    wood: "Wood",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Gold",
    uranium: "Uranium",
  },
  notifications: {
    title: "Notifications",
    loading: "Loading notifications...",
    empty: "No notifications for now.",
    signInRequired: "Sign in to view your notifications.",
    loadError: "Unable to load notifications.",
    userFallback: "User",
  },
  searchFeed: {
    all: "All",
    spots: "Spots",
    videos: "Videos",
    explores: "Explores",
    treasureHunts: "IRL Quests",
    resultsFor: "Results for:",
    noResults: "No results found.",
    availableAt: "Available at {{distance}}",
    unlockOnSite: "Unlock on site",
    channels: "Channels",
  },
  map: {
    filters: {
      subscriptions: "Subscriptions",
      private: "Private",
      all: "All",
    },
    myPosition: "My location",
    searchPlacePlaceholder: "Search Paris, Montmartre...",
    geolocationUnavailable: "Geolocation is unavailable on this device.",
    enableLocationNearby: "Allow location access to unlock nearby content.",
    currentPositionUnavailable: "Unable to get your current location.",
    googleMapsLoadError: "Google Maps could not be loaded.",
    loadExploreSubscriptionsError: "Unable to load Explore subscriptions.",
    loadExplorePointsError: "Unable to load Explore points.",
    loadExploreMapError: "Unable to load the Explore map.",
    loadPointDetailError: "Unable to load point details.",
    loadTreasureHuntError: "Unable to load this IRL quest.",
    noPlaceFound: "No place found for this search.",
    placeNotFound: "Place not found.",
    enableCurrentPositionBeforeSaving: "Enable your current position before saving a point.",
    savePositionError: "Unable to save this position.",
    positionUsableForContent: "This position can be used for content",
    positionSaveFailed: "Unable to save position.",
    stopTreasureHuntError: "Unable to stop this IRL quest.",
    gpsPointLabelPlaceholder: "GPS point label",
  },
  explore: {
    signInToInteract: "Sign in to interact with this explore.",
    likeError: "Unable to like this explore.",
    addCommentError: "Unable to add the comment.",
    addReplyError: "Unable to add the reply.",
    likeCommentError: "Unable to like this comment.",
    requestSent: "Request sent",
  },
  profileMenu: {
    title: "Qubiq profile",
    signedOutDescription:
      "Sign in to access your profile, notifications, and Qubiq player and creator features.",
    myProfile: "My profile",
    editProfile: "Edit my profile",
    notifications: "Notifications",
    notificationsWithCount: "Notifications ({{count}})",
    friendGroups: "Friend groups",
    inviteFriends: "Invite my friends",
    inviteFriendsDesktop: "Invite my friends (+20 qub tokens)",
    createOnQubiq: "Create on Qubiq",
    contactUs: "Contact us",
    creatorWelcomeTitle: "You are now a Qubiq creator 💛",
    creatorWelcomeDesktop:
      "Click the Qubiq Studio button to upload your videos and Explores, and configure your games and quests.",
    creatorWelcomeMobile:
      "Tap the Qubiq Studio button to upload your videos and Explores, and configure your games and quests.",
    contactCreatorMessage:
      "Send me an email at damien@qubiq.tv. I will reply as soon as possible 💛",
    legalInfo: "Legal information",
    language: "Language",
    languageDescription: "Choose the language used across Qubiq.",
    cookiesAndConsent: "Cookies and consent",
    manageCookies: "Manage my cookies",
    openLanguageMenu: "Open language selection",
  },
  friendGroups: {
    title: "Friend groups",
    subtitle: "Create a group and invite other players to join you.",
    signInRequired: "Sign in to access your friend groups.",
    loadError: "Unable to load friend groups.",
    detailLoadError: "Unable to load this friend group.",
    create: "+ Create a group",
    createDialogTitle: "Create a friend group",
    renameDialogTitle: "Rename group",
    groupNameLabel: "Group name",
    groupNamePlaceholder: "e.g. Team Paris",
    confirmCreate: "Create group",
    confirmRename: "Save",
    createError: "Unable to create this group.",
    renameError: "Unable to rename this group.",
    duplicateNameError: "This group name already exists.",
    myGroups: "My groups",
    backToGroups: "Back to groups",
    empty: "You do not have any friend groups yet.",
    untitledGroup: "Untitled group",
    groupCounts: "{{count}} friend(s) · {{pending}} pending request(s)",
    incomingInvitesTitle: "Received invites",
    invitedBy: "Invited by {{username}}",
    accept: "Confirm",
    refuse: "Cancel",
    refuseInviteAction: "Refuse",
    acceptInviteError: "Unable to accept this invite.",
    refuseInviteError: "Unable to refuse this invite.",
    selectGroup: "Choose a group",
    selectGroupDescription: "Select a group on the left to see its friends and send new invites.",
    searchUsersTitle: "Add friend(s)",
    searchPlayersPlaceholder: "Search players",
    searchResults: "Results",
    searching: "Searching...",
    noSearchResults: "No user found.",
    membersTitle: "Group members",
    noMembersYet: "No members yet.",
    addUserDialogTitle: "Add to my friend group?",
    addUserDialogBody: "Do you want to send an invite to {{username}}?",
    confirm: "Confirm",
    cancel: "Cancel",
    inviteError: "Unable to send this invite.",
    friendStatus: "Friend",
    meLabel: "Me",
    requestSentStatus: "Request sent",
    incomingInviteDialogTitle: "Join this friend group?",
    incomingInviteDialogBody: "Do you want to join the group {{groupName}}?",
    leaveGroup: "Leave group",
    leaveDialogTitle: "Leave group",
    leaveDialogBody: "You can always come back later if someone invites you again.",
  },
  inviteFriends: {
    pageTitle: "Invite your friends",
    popupTitle: "Invite your friends to Qubiq",
    popupBodyBeforeReward: "You and your friend earn",
    popupBodyAfterReward: "when they sign up with your link.",
    messageLabel: "Message",
    copyIconLabel: "Copy",
    rewardLine: "20 qubs for your friend and 20 qubs for you",
    helper:
      "Pick contacts if your device supports it. Otherwise, Qubiq opens your device share sheet or copies the message.",
    cta: "Invite my friends",
    copyButton: "Copy message",
    copied: "Message copied",
    loadError: "Unable to prepare your invite link.",
    actionError: "Unable to open the invite flow.",
  },
  cookieConsent: {
    bannerTitle: "Qubiq uses cookies",
    bannerDescription:
      "We use trackers that are necessary for the service to work and, with your consent, audience measurement cookies to better understand how Qubiq is used.",
    bannerDetails:
      "You can accept, refuse, or customize your choices. Refusing is just as easy as accepting, and you can change your preferences later.",
    customize: "Customize",
    refuseAll: "Refuse all",
    acceptAll: "Accept all",
    preferencesTitle: "Manage my cookies",
    preferencesDescription:
      "Choose which trackers can be used on Qubiq. Necessary cookies remain active to allow sign-in, security, and essential service features.",
    analyticsNotice:
      "Google Analytics stays disabled until you accept audience measurement.",
    necessaryTitle: "Necessary cookies",
    necessaryDescription:
      "Sign-in, security, session stability, and essential technical features.",
    analyticsTitle: "Audience measurement",
    analyticsDescription:
      "Google Analytics 4 to measure traffic, performance, and overall use of Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Category reserved for future marketing use. It remains disabled for now.",
    cancel: "Cancel",
    saveChoices: "Save my choices",
  },
  navigation: {
    profile: "Profile",
    home: "Home",
    infoAndRules: "Info & rules",
    creatorsShow: "Our creators put on a show",
    explore: "Explore",
    rankings: "Rankings",
  },
  sidebar: {
    hangout: "Where everyone hangs out",
    welcomeCommunity: "Welcome to the community",
  },
  categories: {
    entertainment: "Entertainment",
    quiz: "Quiz & study",
    science: "Science explainers",
    sport: "Sport",
    esport: "Esport",
    music: "Music",
  },
  visibility: {
    public: "Public",
    notListed: "Unlisted",
    private: "Private",
  },
  ranking: {
    rankingGeneral: "Overall ranking",
    progression: "Progress",
    rankings: "Rankings",
    exploreRankings: "Explore rankings",
    players: "Players",
    channels: "Channels",
    gameMasters: "Game Masters",
    loading: "Loading ranking...",
    loadingProgression: "Loading progression...",
    irlQuest: "IRL Quest",
    overall: "Overall",
    configLoadError: "Unable to load ranking configuration.",
    leaderboardLoadError: "Unable to load ranking.",
    exploreLeaderboardLoadError: "Unable to load Explore ranking.",
    channelLeaderboardLoadError: "Unable to load channel ranking.",
    exploreChannelLeaderboardLoadError: "Unable to load Explore channel ranking.",
    clientNotFound: "Client not found.",
    rankingUserNotFound: "Ranking user not found.",
    progressionLoadError: "Unable to load progression.",
    noChannelFound: "No channel found with that name.",
    noPlayerFound: "No player found with that username.",
    searchChannel: "Looking for a channel?",
    searchPlayer: "Looking for a player?",
    search: "Search",
    position: "Position",
    views: "Views",
    gamesPlayed: "Games played",
    score: "Score",
    level: "Level",
    badge: "Badge",
    victories: "Victories",
    defeats: "Defeats",
    completed: "Completed",
    currentRank: "Current rank",
    progressTo: "Progress toward {{badge}}",
    maxBadgeReached: "Maximum badge reached",
    remainingXp: "{{count}} XP left to reach {{badge}}.",
    finalBadgeReached: "You reached the last available badge tier.",
    summary: "Summary",
    overallRank: "Overall ranking",
    totalGamesPlayed: "Total games played",
    mostPlayedCategory: "Most played category",
    completedHunts: "Completed quests",
    segment: "Segment",
    rank: "Rank",
    games: "Games",
    xpRequired: "Required XP",
    game: "Game",
    xpVictory: "Victory XP",
    xpDefeat: "Defeat XP",
    hardcoreModeX2: "X2 hardcore mode",
    exploreX2: "X2 Explore",
    timeoutZeroXp: "Timeout 0 XP",
    back: "Back",
    category: "Category",
    signInToSubscribe: "Sign in to subscribe",
    youtubeSubscriptionsUnavailable: "Subscriptions unavailable for YouTube channels",
    subscriberCount: "{{count}} subscribers",
    unranked: "Unranked",
    none: "None",
    rules: {
      useCase: "Use Case",
      reward: "Reward",
      info: "Info",
      gameVictoryLabel: "Game victory",
      gameVictoryReward: "+215 qubs / +4 XP",
      gameVictoryInfo: "Reward unlocked only once per game.",
      quizVictoryLabel: "Quiz victory",
      quizVictoryInfo: "Given only once per game.",
      questionAnswerVictoryLabel: "Question Answer victory",
      questionAnswerVictoryInfo: "Given only once per game.",
      defeatLabel: "Defeat",
      defeatReward: "−1 XP",
      defeatInfo: "If timeout: 0 XP",
      questCompletedLabel: "Quest completed",
      questCompletedReward: "+20 XP",
      questCompletedInfo: "Given for each completed quest",
      creatorGamePlayLabel: "Game played on your content",
      creatorGamePlayReward: "+5 qubs / +1 XP",
      creatorGamePlayInfo: "Given once per creator, game, and player triplet, win or loss",
      exploreLikeReceivedLabel: "Like on your explore",
      exploreLikeReceivedReward: "+1 qub / +1 XP",
      exploreLikeReceivedInfo: "Given only once per user and per explore",
      exploreViewReceivedLabel: "View on your explore",
      exploreViewReceivedReward: "+1 qub",
      exploreViewReceivedInfo: "Given for each new qualified session",
      firstMomentOfDayLabel: "First Moment of the day",
      firstMomentOfDayReward: "+50 qubs",
      firstMomentOfDayInfo: "Post your first Moment of the day to unlock your daily reward.",
    },
  },
  profile: {
    notFound: "Profile not found.",
    loadError: "Unable to load this profile.",
    signInToSubscribe: "Sign in to subscribe.",
    subscribeFailed: "Subscription failed.",
    deletePostFailed: "Unable to delete this post.",
    likePostFailed: "Unable to like this post.",
    updateQubsVisibilityFailed: "Unable to update qubs visibility.",
    videos: "Videos",
    explores: "Explores",
    treasureHunts: "IRL Quests",
    history: "History",
    wallet: "Wallet",
    noVideosWatched: "No watched videos yet.",
    viewedDuration: "Watched {{duration}}",
    signInToLike: "Sign in to like a post.",
    recapGames: "Game recap",
    hardcoreRun: "Hardcore run",
    normalRun: "Normal run",
    gamesCount: "{{count}} game",
    gamesCount_other: "{{count}} games",
    victoriesCount: "{{count}} victory",
    victoriesCount_other: "{{count}} victories",
    defeatsCount: "{{count}} defeat",
    defeatsCount_other: "{{count}} defeats",
    gains: "Gains",
    walletDescription: "Total number of qubs currently available in your wallet.",
    noExploreWatched: "No Explore watched yet.",
    noTreasureHuntStarted: "No IRL quest started yet.",
    treasureHuntCompleted: "Completed",
    treasureHuntInProgress: "In progress",
    treasureHuntStarted: "Started",
    userFallback: "User",
    subscribed: "Subscribed",
    subscribe: "Subscribe",
    subscriberCount: "{{count}} subscribers",
    levelShort: "Lvl.",
    showQubsTitle: "Show my qubs",
    showQubsDescription: "Display your qub balance on your public profile.",
    noPostsTitle: "No posts yet",
    noPostsDescription: "Video shares and run recap shares will appear here.",
    runOverviewLabel: "Qubiq Run Overview",
    hardcoreGauge: "HARDCORE GAUGE",
    xp: "XP",
    hardcore: "Hardcore",
    normal: "Normal",
    questionAnswer: "Question Answer",
    victory: "Victory",
    defeat: "Defeat",
    questionNumber: "Question {{count}}",
    recapPage: "Recap page",
    videoLabel: "Video",
    deletePostTitle: "Delete this post?",
    deletePostDescription: "This action will remove the post from your Qubiq profile.",
    cancel: "Cancel",
    delete: "Delete",
  },
  bannerCounter: {
    loadError: "Unable to load wallet.",
    offline: "offline",
  },
  studio: {
    explorePublicGpsRequired: "Link this Explore to a GPS location before making it public.",
    explorePrivateGpsRequired: "Link this Explore to a GPS location before granting private access.",
    title: "Qubiq Studio",
    createAction: "Create",
    viewChannel: "View my profile",
    subtitle: "Manage your channel, upload your videos, and configure your games",
    loading: "Loading...",
    signInRequired: "Sign in to access Studio.",
    channel: "Channel",
    profile: "Edit my profile",
    questsAndExplores: "Quests & Explores",
    videos: "Videos",
    explores: "Explores",
    exploresDescription:
      "Explores are short videos that you can place in specific real-world locations.\n\nSave the GPS position of a place you discover, then hide an Explore or an IRL Quest step there.",
    treasureHunts: "IRL Quests",
    myChannel: "My channel",
    archives: "Archives",
    statusUploading: "Uploading",
    statusProcessing: "Processing",
    statusReady: "Ready",
    statusError: "Error",
    gpsPosition: "GPS position",
    manageGpsPoints: "Manage my GPS points",
    manageGpsPointsDescription: "Find, rename, and delete the GPS positions saved for your Explores.",
    backToExplores: "Back to Explores",
    gpsPointSearchPlaceholder: "Search a GPS point by name",
    gpsPointLabel: "GPS point name",
    unnamedGpsPoint: "Unnamed GPS point",
    noGpsPoints: "No GPS points saved yet.",
    noGpsPointSearch: "No GPS point matches this search.",
    gpsPointInUse: "Used by {{count}} Explore(s)",
    gpsPointUnused: "This point is not used by any Explore.",
    deleteGpsPoint: "Delete point",
    gpsPointDeleteQuestion: "Permanently delete \"{{label}}\"?",
    gpsPointDeleteBlocked: "This point is used by {{count}} Explore(s). Remove it from those Explores before deleting it.",
    loadMoreGpsPoints: "Load more points",
    gpsPointsCount: "{{count}} GPS point(s)",
    gpsMapUnavailable: "The Maps preview is unavailable. The coordinates are still shown above.",
    laptop: "Laptop",
    tablet: "Tablet",
    smartphone: "Smartphone",
    durationCheckError: "Unable to check this video duration.",
    uploadFinishedProcessing: "Upload complete. Quality processing and encoding are in progress.",
    verticalPreviewInfo: "Only one vertical preview is shown for Explores.",
    noFileSelected: "No file selected",
    profileSaved: "Channel profile saved.",
    profileSaveError: "Unable to save channel profile.",
    loadVideosError: "Unable to load videos.",
    loadChannelError: "Unable to load channel.",
    archiveUpdateError: "Unable to update archive.",
    loadGpsPositionsError: "Unable to load GPS positions.",
    gpsPositionUsed: "GPS position used",
    gpsPositionRemoved: "GPS position removed",
    editDetails: "Edit details",
    noAuthorizedEmail: "No authorized email for now.",
    exploreGpsPosition: "GPS position of your Explore",
    activeGpsPosition: "Active GPS position",
    removeGpsPosition: "Remove GPS position",
    saving: "Saving...",
    updating: "Updating...",
    save: "Save",
    saveGame: "Save game",
    cancel: "Cancel",
    noGamesConfigured: "No game configured.",
    edit: "Edit",
    editPhoto: "Edit photo",
    savingProfile: "Saving...",
    saveProfile: "Save profile",
    noArchivedExplore: "No archived Explore for now.",
    noArchivedVideo: "No archived video for now.",
    noArchivedExploreSearch: "No archived Explore matches this search.",
    noArchivedVideoSearch: "No archived video matches this search.",
    loadingVideos: "Loading videos...",
    noExploreYet: "No Explore for now.",
    noVideoYet: "No video for now.",
    noExploreSearch: "No Explore matches this search.",
    noVideoSearch: "No video matches this search.",
    noDescription: "No description.",
    untitled: "Untitled",
    viewsCount: "{{count}} views",
    archiving: "Archiving...",
    confirm: "Confirm",
    loadingAccess: "Loading access...",
    noLinkedAccount: "No linked account for now",
    close: "Close",
    quizFirstTwoAnswersRequired: "The first two answers are required for {{game}}.",
    chooseCorrectAnswer: "Choose the correct answer.",
    correctAnswerMustBeFilled: "The correct answer must point to a filled answer.",
    shortAnswerRequired: "The correct answer is required for {{game}}.",
    configureChannel: "Configure my channel",
    profilePhotoAlt: "Profile photo",
    firstName: "First name",
    lastName: "Last name",
    username: "Username",
    bio: "Bio",
    channelName: "Username",
    channelNameHelper: "Automatically synced with Clerk. If you change it here or in Clerk, it updates on both sides.",
    channelDescription: "Your channel description",
    statusLabel: "Status",
    draftStatus: "Draft",
    publishedStatus: "Published",
    treasureHuntPrivateStatus: "Private",
    treasureHuntPublishedStatus: "Published",
    authorizedEmailsLabel: "Authorized emails",
    authorizedEmailsHelper: "One email per line, or separated by commas.",
    titleLabel: "Title",
    categoryLabel: "Category",
    visibilityLabel: "Visibility",
    descriptionLabel: "Description",
    archivedVideosTab: "Videos",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Search archived videos by title",
    archivedExploreSearchPlaceholder: "Search archived Explores by title",
    videoSearchPlaceholder: "Search videos by title",
    exploreSearchPlaceholder: "Search Explores by title",
    removeFromArchives: "Remove from archives",
    addVideo: "Add a video",
    addExplore: "Add an Explore",
    refresh: "Refresh",
    archive: "Archive",
    archiveVideoTitle: "Archive video",
    deleteExplore: "Delete",
    deleteExploreTitle: "Permanently delete this Explore?",
    deleteExploreQuestion: "This Explore and its files will be permanently deleted. This cannot be undone. Evidence needed for any reports is retained in accordance with our privacy policy.",
    deletingExplore: "Deleting...",
    deletedExplore: "Explore deleted.",
    deleteExploreError: "Unable to delete this Explore. Please try again.",
    deletionErrors: {
      explore_archive_required: "Archive this Explore before deleting it.",
      explore_processing: "The video is still processing. Try again when processing has finished.",
      explore_not_found: "This Explore is no longer available.",
      explore_deletion_unavailable: "Deletion is temporarily unavailable. Please try again later.",
    },
    archiveVideoQuestion: "Are you sure you want to archive this video?",
    archiveExploreQuestNotice: "This Explore will also be removed from its current IRL Quest.",
    archivedVideoSuccess: "Video archived.",
    removedFromArchivesSuccess: "Video removed from archives.",
    searchArchivedThumbnailAlt: "Video thumbnail",
    thumbnailFallback: "Thumbnail",
    thumbnailUpdated: "Thumbnail updated.",
    thumbnailUploadError: "Unable to upload thumbnail.",
    uploadCancelled: "Upload cancelled.",
    chooseThumbnail: "Choose a thumbnail.",
    chooseImageFormat: "Choose a JPG, PNG, or WebP image.",
    thumbnailMaxSize: "Thumbnail must be 5 MB max.",
    chooseProfilePhoto: "Choose a profile photo.",
    profilePhotoMaxSize: "Profile photo must be 5 MB max.",
    usernameRequired: "Username is required.",
    saveChannelError: "Unable to save channel.",
    verificationCancelled: "Verification cancelled. The profile was not updated.",
    copied: "Copied!",
    copyFailed: "Unable to copy.",
    resolveEmailsError: "Unable to verify private access.",
    loadPrivateAccessError: "Unable to load private access.",
    privateAccessTitle: "Private explore access",
    configurePrivateAccessTitle: "Manage private access",
    addEmailsError: "Unable to add private access.",
    addPrivateAccessUserError: "Unable to add this user.",
    privateAccessSearchError: "Unable to search users.",
    privateAccessUserMissingEmail: "This account does not have a usable email for private access.",
    saveUsernameBeforeUpload: "Save a username before creating an Explore.",
    chooseVideoToUpload: "Choose a video to upload.",
    prepareUploadError: "Unable to prepare upload.",
    uploadToServerError: "Unable to upload to the server.",
    uploadToStorageError: "Unable to upload to storage.",
    storageFailed: "Video storage failed.",
    postUploadPreparationError: "Video preparation after upload failed.",
    uploadFailed: "Upload failed.",
    exploreMaxDuration: "An Explore must be 3 minutes maximum.",
    titleRequired: "Choose a title to save.",
    gpsPositionRequired: "Choose a GPS position to save.",
    chooseCategory: "Choose a category.",
    chooseVisibility: "Choose a visibility.",
    updateVideoError: "Unable to update video.",
    videoUpdated: "Video updated.",
    videoUpdateFailed: "Unable to update video.",
    assignGpsPositionError: "Unable to assign this GPS position.",
    gpsPositionProximityInfo:
      "This content will only be visible to users near this GPS position.",
    geolocationUnavailable: "Geolocation is unavailable on this device.",
    currentPositionUnavailable: "Unable to retrieve your current position.",
    saveCurrentPositionError: "Unable to save the current position.",
    useCurrentPositionError: "Unable to use the current position.",
    gpsLabelUpdated: "GPS label saved.",
    gpsLabelUpdateError: "Unable to update this label.",
    removeGpsPositionError: "Unable to remove GPS position.",
    gpsPositionRestrictionRemoved:
      "This content is no longer restricted to users near the GPS position.",
    viewVideo: "View video",
    dateLabel: "Date",
    viewsLabel: "Views",
    changeThumbnail: "Change thumbnail",
    uploadThumbnail: "Uploading thumbnail...",
    managePrivateAccess: "Manage private access",
    treasureHuntPrivateAccessTitle: "Manage private access",
    treasureHuntPrivateAccessLead: "Want to keep your quest intimate?",
    treasureHuntPrivateAccessDescription:
      "Grant access only to the users you choose.",
    privateExploreStatus: "Private",
    exploreInheritsQuestVisibilityPublished: "Inherits the quest status: Published",
    exploreInheritsQuestVisibilityPrivate: "Inherits the quest status: Private",
    authorizedEmailsCount: "{{count}} private access",
    addEmails: "Add private access",
    add: "Add",
    validate: "Save",
    privateAccessLead: "Want to keep your Explore intimate?",
    privateAccessDescription:
      "Grant access only to the users you choose.",
    searchUsers: "Search users",
    searchUsersPlaceholder: "Search a username",
    searchResults: "Results",
    searchingUsers: "Searching...",
    noPrivateAccessSearchResults: "No users found.",
    selected: "Selected",
    userFallbackUsername: "user",
    videoLink: "Video link",
    copyVideoLink: "Copy video link",
    accountNotFound: "Account not found",
    unlistedVideoTitle: "Unlisted video",
    unlistedVideoDescription:
      "This video will not appear in the feed or suggestions. It will only be accessible through its direct link.",
    exploreLocationHelp:
      "Explores are attached to a place. Only people who get close to your Explore will be able to open it.",
    useGpsPosition: "Use a GPS position",
    accessRadius: "Access radius:",
    attachExploreToPlace: "Attach your Explore to a place.",
    viewsBeforeDisappearance: "Number of views before disappearance",
    noLimitHelper: "Leave empty if you do not want a limit.",
    oneViewPerUser: "Check to make this Explore visible only once per user",
    hiddenExactPosition:
      "Check to hide the exact position within 100 m around the Explore",
    previewHelp:
      "Check how the video and games render on laptop, tablet, and smartphone.",
    screenPreview: "Screen preview",
    explorePreview: "Explore preview",
    fullScreen: "Full screen",
    exitFullScreen: "Exit full screen",
    back: "Back",
    portraitView: "Portrait view",
    landscapeView: "Landscape view",
    backToMyVideos: "Back to my explores",
    preparingVideo: "Video preparation",
    globalLabel: "Global",
    hardcoreMode: "Hardcore mode",
    hardcoreDescription:
      "In hardcore mode, the player doubles their gains after each correct answer. Gains stack in a meter, but one mistake loses everything.",
    understood: "Understood",
    treasureHuntPrefix: "IRL Quest: {{title}}",
    gamesLoadError: "Unable to load games.",
    gameScheduleOverlapAt:
      'With "Pause video" disabled, this game overlaps the game scheduled at {{time}}.',
    globalPauseDisableError:
      "Unable to disable video pause globally: games at {{left}} and {{right}} would overlap.",
    chooseGameType: "Choose a game type.",
    invalidGameMoment: "Enter a valid moment in 00:00 or 00:00:00 format.",
    gameEndAfterTimer: "The end timecode must be greater than or equal to the game timer.",
    gameMomentWithinDuration:
      "The game moment must be within the video duration ({{max}} max).",
    gameEndWithinDuration:
      "The game end timecode must be within the video duration ({{max}} max).",
    answerTimePositive: "Enter an answer time greater than 0 seconds.",
    gameStartBeforeVideoEnd:
      "The game start timecode plus the timer must end at least {{margin}} seconds before the end of the video ({{max}}), to leave time for animation and rewards.",
    gameMomentWithinDurationShort: "The game moment must be within the video duration.",
    gameOverlapWithoutPause:
      'This game overlaps another game with the "Pause video" rule disabled.',
    videoDurationUnavailable:
      "Video duration is unavailable. Wait until processing is complete before adding a game.",
    saveGameError: "Unable to save game.",
    gameSaved: "Game saved.",
    gameSaveFailed: "Unable to save game.",
    applyGlobalSettingsOverlap:
      "Unable to apply these settings: some games would overlap.",
    applyGlobalSettingsError: "Unable to apply global settings.",
    globalSettingsApplied: "Global settings applied.",
    configureGame: "Configure {{game}}",
    editGame: "Edit {{game}}",
    gameMoment: "Moment",
    gameStartTimecode: "Start timecode",
    gameEndTimecode: "End timecode",
    timeFormatHelper: "Use 00:00 or 00:00:00.",
    gameStartsAt: "The game starts at this moment.",
    gameEndsAt: "The game ends at this moment.",
    answerTime: "Answer time",
    secondsToAnswer: "seconds to answer",
    timecodeReference: "Timecode reference",
    gameStartReference: "Game start timecode",
    gameEndReference: "Game end timecode",
    question: "Question",
    answerOne: "Answer 1",
    answerTwo: "Answer 2",
    answerThree: "Answer 3",
    answerFour: "Answer 4",
    correctAnswer: "Correct answer",
    expectedAnswer: "Expected answer",
    expectedAnswerHelper: "The player's answer will be normalized before comparison.",
    successMessage: "Success message",
    failureMessage: "Failure message",
    globalPauseModeActive: "Global config active: pause mode is defined at the video level",
    pauseVideoDuringGame: "Pause video during the game",
    hardcoreAnswersGlobal:
      "Hardcore mode active: multiple answers are defined globally",
    allowMultipleAnswers: "Allow multiple answers",
    hardcoreRegainGlobal: "Hardcore mode active: regain is defined globally",
    enableMultipleAnswersFirst: "Enable multiple answers first to allow regain",
    allowRegainEachVictory: "Allow regain on each victory",
    globalGameConfig: "Global config for this video's games",
    hardcoreWholeVideo: "Hardcore mode for the whole video",
    pauseAllGames: "Pause video on all games in this video",
    pauseCannotDisable: "Video pause cannot be disabled for now.",
    overlappingGamesWithoutPause: "These games would overlap without pause:",
    allowMultipleAnswersAllHardcore:
      "Allow multiple answers on all hardcore games",
    allowRegainAllHardcore: "Allow regain on all hardcore games",
    hardcoreGlobalAllocation:
      "Hardcore mode forces global allocation. Replay and regain are configured above.",
    applyToAllGames: "Apply to all games",
    addGame: "Add a game",
    removeGameError: "Unable to remove the game.",
    removeGameFailed: "Game could not be removed.",
    gameDisabled: "Game disabled.",
    disableGame: "Disable",
    irlQuestCardLabel: "IRL Quest",
    newTreasureHunt: "New IRL Quest",
    treasureHuntsLoadError: "Unable to load IRL Quests.",
    treasureHuntCreated: "IRL Quest created.",
    treasureHuntSaved: "IRL Quest saved.",
    treasureHuntDeleted: "IRL Quest deleted.",
    availableExploresLoadError: "Unable to load available Explores.",
    exploresAddedToQuest: "Explores added to the IRL Quest.",
    reorderExploresError: "Unable to reorder Explores.",
    exploreRemovedFromQuest:
      "Explore removed from the IRL Quest. It becomes visible again on the regular map if public.",
    removeExploreFromQuestError: "Unable to remove this Explore.",
    treasureHuntThumbnailUpdated: "Quest thumbnail updated.",
    configureTreasureHunt: "Select an IRL Quest to configure it.",
    treasureHuntName: "Quest name",
    addExistingExplores: "Add existing Explores",
    noExploreInTreasureHunt: "No Explore in this IRL Quest yet.",
    noCategory: "No category",
    moveUp: "Move up",
    moveDown: "Move down",
    remove: "Remove",
    savingTreasureHunt: "Saving...",
    saveTreasureHunt: "Save Quest",
    delete: "Delete",
    treasureHuntsDescription:
      "IRL Quests are Explore routes designed to be completed step by step.\n\nPlayers must find each location and succeed at the games inside each Explore to unlock every step.",
    createNewExplore: "Create a new Explore",
    createTreasureHunt: "Create an IRL Quest",
    searchTreasureHunt: "Search a Quest by title",
    treasureHuntCount: "{{count}} Explore(s)",
    noTreasureHuntYet: "No IRL Quest for now.",
    noTreasureHuntSearch: "No IRL Quest matches this search.",
    signInToStartTreasureHunt: "Sign in to start the quest.",
    replayable: "Replayable",
    oneAttempt: "One attempt",
    addExistingExploresTitle: "Add existing Explores",
    outsideMapWarning:
      "Explores already linked to another IRL Quest will be removed from their current Quest.",
    loadingAvailableExplores: "Loading available Explores...",
    noAvailableExplore: "No Explore available to add.",
    deleteTreasureHuntTitle: "Delete Quest",
    deleteTreasureHuntDescription:
      "This action permanently deletes the IRL Quest without deleting its Explores.",
    deleting: "Deleting...",
  },
  videoDetail: {
    sharePrivateDisabled: "Sharing private videos is disabled.",
    signInToPostProfile: "Sign in to post on your profile.",
    publishedOnProfile: "Published on your profile.",
    shared: "Shared!",
    linkCopiedOpenApp: "Link copied. Open the app to paste it.",
    shareFailed: "Unable to share.",
    copySuccess: "Copied!",
    copyFailed: "Unable to copy.",
  },
  languageDialog: {
    title: "Language",
    description: "Choose the language used on Qubiq. Unsupported browser languages automatically fall back to English.",
    close: "Close",
  },
  legalLinks: {
    terms: "Terms",
    legal: "Legal notice",
    privacy: "Privacy",
    cookies: "Cookies",
    moderation: "Moderation",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
